/** Major currency units: digits with at most one decimal point and two fractional digits. */
export function sanitizeAmountInput(raw: string): string {
  let v = raw.replace(/[^\d.]/g, "");
  const dot = v.indexOf(".");
  if (dot === -1) return v;
  const intPart = v.slice(0, dot);
  const frac = v.slice(dot + 1).replace(/\./g, "");
  return `${intPart}.${frac.slice(0, 2)}`;
}
